import { render, staticRenderFns } from "./WebCategory.vue?vue&type=template&id=e83ffea0&"
import script from "./WebCategory.vue?vue&type=script&lang=js&"
export * from "./WebCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports